import { render } from "./GeoReferencing.vue?vue&type=template&id=6d30815d&scoped=true"
import script from "./GeoReferencing.vue?vue&type=script&lang=js"
export * from "./GeoReferencing.vue?vue&type=script&lang=js"

import "./GeoReferencing.vue?vue&type=style&index=0&id=6d30815d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d30815d"]])

export default __exports__